module.exports = __webpack_public_path__ + "img/1505241512.bb8272d5.jpg";